export default "__VITE_ASSET__CDETWOTf__"